// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".headerIcon {\n  font-size: 24px;\n  color: #788195;\n  flex-shrink: 0;\n  cursor: pointer;\n  transition: color 0.2s ease, transform 0.2s ease;\n}\n.headerIcon:hover {\n  color: #2d3446;\n  transform: scale(1.2);\n}\n", ""]);
// Exports
module.exports = exports;
